import React from 'react';
import RichContent from '../content/RichContent';
import gsocJourneyHtmlUrl from './content/gsoc-2026-reverse-engineering-journey.txt';

export default function GsocJourneyBlog() {
    return <RichContent htmlFileUrl={gsocJourneyHtmlUrl} />;
}
